export default __webpack_public_path__ + "static/media/default-avatar.92e83fe5.png";